import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "", ...rest }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={reduce ? undefined : { opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
      {...rest}
    >
      {children}
    </motion.div>
  );
};

export const MaskReveal = ({ children, delay = 0, className = "", immediate = false }) => {
  const reduce = useReducedMotion();
  const animProps = immediate
    ? { animate: reduce ? undefined : { y: 0 } }
    : { whileInView: reduce ? undefined : { y: 0 }, viewport: { once: true } };
  return (
    <span className={`mask-line ${className}`}>
      <motion.span
        className="mask-inner"
        initial={reduce ? false : { y: "112%" }}
        {...animProps}
        transition={{ duration: 1.05, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </span>
  );
};

export { EASE };
